import { createTheme } from "@mui/material/styles";
// @ts-ignore
import tokens from "./tokens.js";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: { main: tokens.colors.brand.primary },
    secondary: { main: tokens.colors.brand.secondary },
    error: { main: tokens.colors.brand.danger },
    warning: { main: tokens.colors.brand.warning },
    success: { main: tokens.colors.brand.success },
    text: {
      primary: tokens.colors.text.default,
      secondary: tokens.colors.text.muted,
    },
    background: {
      default: tokens.colors.background.default,
      paper: tokens.colors.background.default,
    },
    divider: tokens.colors.gray[300],
  },
  shape: {
    borderRadius: tokens.radius.md,
  },
  typography: {
    fontFamily: tokens.typography.body.family,
    h1: {
      fontSize: tokens.typography.h1.size,
      fontWeight: tokens.typography.h1.weight,
      lineHeight: tokens.typography.h1.line,
    },
    h2: {
      fontSize: tokens.typography.h2.size,
      fontWeight: tokens.typography.h2.weight,
      lineHeight: tokens.typography.h2.line,
    },
    h3: {
      fontSize: tokens.typography.h3.size,
      fontWeight: tokens.typography.h3.weight,
      lineHeight: tokens.typography.h3.line,
    },
    body1: {
      fontSize: tokens.typography.body.size,
      fontWeight: tokens.typography.body.weight,
      lineHeight: tokens.typography.body.line,
    },
    body2: {
      fontSize: tokens.typography.bodySm.size,
      fontWeight: tokens.typography.bodySm.weight,
      lineHeight: tokens.typography.bodySm.line,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "@font-face": [
          {
            fontFamily: tokens.typography.body.family,
            fontStyle: "normal",
            fontDisplay: "swap",
          },
        ],
        html: {
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
        body: {
          WebkitFontSmoothing: "antialiased",
          MozOsxFontSmoothing: "grayscale",
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: tokens.radius.md,
          textTransform: "none",
          fontWeight: 600,
          padding: "8px 16px",
        },
      },
      variants: [
        {
          props: { variant: "contained", color: "primary" },
          style: {
            backgroundColor: tokens.buttons.primary.bg,
            color: tokens.buttons.primary.text,
            "&:hover": {
              backgroundColor: tokens.buttons.primary.hover,
            },
          },
        },
        {
          props: { variant: "outlined", color: "primary" },
          style: {
            borderColor: tokens.buttons.secondary.border,
            color: tokens.buttons.secondary.text,
            "&:hover": {
              backgroundColor: tokens.buttons.secondary.hoverBg,
            },
          },
        },
        {
          props: { variant: "contained", color: "error" },
          style: {
            backgroundColor: tokens.buttons.danger.bg,
            color: tokens.buttons.danger.text,
            "&:hover": {
              backgroundColor: tokens.buttons.danger.hover,
            },
          },
        },
        {
          props: { variant: "contained", color: "warning" },
          style: {
            backgroundColor: tokens.buttons.warning.bg,
            color: tokens.buttons.warning.text,
            "&:hover": {
              backgroundColor: tokens.buttons.warning.hover,
            },
          },
        },
      ],
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: tokens.shadow.card,
          borderRadius: tokens.radius.lg,
        },
      },
    },
  },
});

export default theme;
